import {GenericoTipoEnum} from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum TipoProspeccao {
  Fisica = 'Fisica',
  Juridica = 'Juridica'
}

export class TipoProspeccaoEnum extends GenericoTipoEnum<TipoProspeccao> {
  static readonly Fisica = new TipoProspeccaoEnum(TipoProspeccao.Fisica, 'Física');
  static readonly Juridica = new TipoProspeccaoEnum(TipoProspeccao.Juridica, 'Jurídica');
}
